import React, { useState } from 'react'
// import ClosedSidebar from '../components/closedSidebar'
// import OpenedSidebar from "../components/openedSidebar"
// import Pagination from '../components/Pagination';
import EmptyState from '../EmptyState';

const data = [

];

const Card = ({ name, capacity, supervisor}) => {
  return (
    <div className='bg-white rounded-2xl py-4 px-5'>
      <div className='flex flex-col gap-2 items-start py-4 border-b font-medium'>
        <span className='flex items-center gap-1'>
            <h1 className='text-tertiary text-[1.05rem] '>{name}</h1>
        </span>
        <div className='flex items-center gap-3'>
            <span className='flex gap-1 items-center'>
                <h1 className='text-[#2F485866] text-sm '>Capacity</h1>
                <p className='text-secondary'>{capacity}</p>
            </span>
            <span className='flex gap-1 items-center'>
                <h1 className='text-[#2F485866] text-sm '>Supervisor</h1>
                <p className='text-secondary line-clamp-1'>{supervisor}</p>
            </span>
        </div>
      </div>
      <div className='py-4 flex items-center justify-between'>
        <button className='bg-primary rounded-full  h-10 px-5 text-white font-medium text-sm'>
            Group
        </button>
        <button className='bg-primary rounded-full  h-10 px-5 text-white font-medium text-sm'>
            Edit
        </button>
        <button className='bg-none text-sm border-2 border-primary rounded-full  h-10 px-5 text-primary font-medium'>
            Delete
        </button>
      </div>
    </div>
  );
};

function Tents() {
  const [isOpened, setIsOpened] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(12);

  const handlePerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const totalItems = data.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentData = data.slice(startIndex, endIndex);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const toggleSidebar = () => {
    setIsOpened(!isOpened);
  };

  return (
    <main className=" font-sans flex">
      {/* {isOpened ? (
        <OpenedSidebar toggleSidebar={toggleSidebar} />
      ) : (
        <ClosedSidebar toggleSidebar={toggleSidebar} />
      )} */}
        <section className="w-full bg-[#F9F9F9] px-20 pt-10" >
            <h1 className='text-2xl text-tertiary font-medium'>Tents</h1>
            <div className='w-full h-20 bg-white mt-10 rounded-lg flex items-center justify-between px-5'>
                <div className='relative w-[30%]'>
                    <svg className='absolute right-5 top-3' xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20" fill="none">
                    <path d="M14.1668 14.1667L17.5001 17.5M2.50012 9.16667C2.50012 10.9348 3.2025 12.6305 4.45274 13.8807C5.70299 15.131 7.39868 15.8333 9.16679 15.8333C10.9349 15.8333 12.6306 15.131 13.8808 13.8807C15.1311 12.6305 15.8335 10.9348 15.8335 9.16667C15.8335 7.39856 15.1311 5.70286 13.8808 4.45262C12.6306 3.20238 10.9349 2.5 9.16679 2.5C7.39868 2.5 5.70299 3.20238 4.45274 4.45262C3.2025 5.70286 2.50012 7.39856 2.50012 9.16667Z" stroke="#2F4858" strokeOpacity="0.6" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <input type='text' placeholder='Search...' className='outline-primary text-secondary bg-[#FFFFFF] border-2 border-[#EFEFEF] h-10 pl-3 rounded-full w-full' />
                </div>
                <button className='text-white bg-primary rounded-full w-48 font-medium h-10'>
                    Add new Participant
                </button>
            </div>

            <Card name="bla"
                capacity="3"
                supervisor="Hanz"
                >
                    test
                </Card>

            {data && data.length > 0 ? (
              <>
                <div className='mt-10 grid grid-cols-3 auto-rows-fr gap-4 '>
                    {currentData.map((dat, index) => (
                        <Card key={index} {...dat} />
                    ))}
                </div>



                {/* <Pagination
                  handlePageChange={handlePageChange}
                  totalPages={totalPages}
                  currentPage={currentPage}
                  itemsPerPage={itemsPerPage}
                  handlePerPageChange={handlePerPageChange}
                /> */}
              </>
              ) : (
                <EmptyState />
            )}
        </section>
    </main>
  )
}

export default Tents